/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { GetPatientAvatarParams } from './api.schemas';

import { api } from '../util/http';

export const getPatientAvatar = (params?: GetPatientAvatarParams, signal?: AbortSignal) => {
  return api<Blob>({
    url: `/api/patient/avatar`,
    method: 'GET',
    params,
    responseType: 'blob',
    signal,
  });
};

export const getGetPatientAvatarQueryKey = (params?: GetPatientAvatarParams) => {
  return [`/api/patient/avatar`, ...(params ? [params] : [])] as const;
};

export const getGetPatientAvatarQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientAvatar>>,
  TError = void,
>(
  params?: GetPatientAvatarParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientAvatar>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientAvatarQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientAvatar>>> = ({ signal }) =>
    getPatientAvatar(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientAvatar>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientAvatarQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientAvatar>>>;
export type GetPatientAvatarQueryError = void;

export function useGetPatientAvatar<
  TData = Awaited<ReturnType<typeof getPatientAvatar>>,
  TError = void,
>(
  params: undefined | GetPatientAvatarParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientAvatar>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientAvatar>>,
          TError,
          Awaited<ReturnType<typeof getPatientAvatar>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientAvatar<
  TData = Awaited<ReturnType<typeof getPatientAvatar>>,
  TError = void,
>(
  params?: GetPatientAvatarParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientAvatar>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientAvatar>>,
          TError,
          Awaited<ReturnType<typeof getPatientAvatar>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientAvatar<
  TData = Awaited<ReturnType<typeof getPatientAvatar>>,
  TError = void,
>(
  params?: GetPatientAvatarParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientAvatar>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPatientAvatar<
  TData = Awaited<ReturnType<typeof getPatientAvatar>>,
  TError = void,
>(
  params?: GetPatientAvatarParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientAvatar>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPatientAvatarQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
